export type NavItem = {
  label: string
  /** Route path for pages, or an in-page anchor on the homepage. */
  to: string
  kind: 'route' | 'section'
}

export const navItems: NavItem[] = [
  { label: 'Home', to: '/', kind: 'route' },
  { label: 'Solutions', to: '/#solutions', kind: 'section' },
  { label: 'Portfolio', to: '/portfolio', kind: 'route' },
  { label: 'Why WebsiteForge', to: '/#why-custom', kind: 'section' },
  { label: 'How Pricing Works', to: '/pricing', kind: 'route' },
]
